type Breakpoints = string[];

type MediaSize = {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
  nav: string;
};

export const breakpointMap: { [key: string]: number } = {
  xs: 390,
  sm: 576,
  mdsmall: 768,
  md: 820,
  lg: 968,
  xl: 1080,
  xxl: 1200,

};

const breakpoints: Breakpoints = Object.values(breakpointMap).map((breakpoint) => `${breakpoint}px`);

const mediaQueries: MediaSize = {
  xs: `@media screen and (max-width: ${breakpointMap.xs}px)`,
  sm: `@media screen and (max-width: ${breakpointMap.sm}px)`,
  md: `@media screen and (max-width: ${breakpointMap.md}px)`,
  lg: `@media screen and (max-width: ${breakpointMap.lg}px)`,
  xl: `@media screen and (max-width: ${breakpointMap.xl}px)`,
  xxl: `@media screen and (max-width: ${breakpointMap.xxl}px)`,
  nav: `@media screen and (max-width: ${breakpointMap.lg}px)`,
};

const logger = {
  breakpoints,
  mediaQueries,
};

export default logger;
